import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h2 futura bold color="#30ABBD" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/Raku-Japanese-Kitchen-346496209289409/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Raku Sushi Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/raku-japanese-kitchen-west-vancouver">
              <CFImage w="45px" pr="10px" src={yelp} alt="Raku Sushi Yelp" />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/amigo-cafe-port-coquitlam">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Raku Sushi Zomato"
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Raku Sushi Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#30ABBD" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/Raku-Japanese-Kitchen-346496209289409/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Raku Sushi Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/raku-japanese-kitchen-west-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Raku Sushi Yelp"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/amigo-cafe-port-coquitlam">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Raku Sushi Zomato"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Raku Sushi Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
